import { Page } from "@/App/Page";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { signedInRoutes } from "@/Routers/signedInRoutes";

function DashboardRouter() {
  const { user } = useAuthentication();

  return (
    <>
      {signedInRoutes(user?.email).map(({ path, element }) => (
        <Page key={path} exact path={path}>
          {() => element}
        </Page>
      ))}
    </>
  );
}
export default DashboardRouter;
